import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { UserInvitation } from '../clients-module/models/clientLocation';
import { UserLight } from '../users-module/models/userLight';
import { environment } from 'src/environments/environment';
import { HardDeclineReason } from '../models/hardDeclineReason';
import { ChannelService } from './channel.service';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {Location} from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { PBUser } from '../users-module/models/pb-user';
import { SupportIssueService } from '../issue-tracker/services/support-issue.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  titleBarText : string;
  sso : boolean;
  postLoginRedirect : string;
  hasRedirect : boolean;
  loggedInUserRoles : Array<string>;
  loggedInUser : UserLight;
  roleFetchComplete : Subject<any> = new Subject<any>();
  userFetchComplete : Subject<any> = new Subject<any>();
  logoutComplete : Subject<any> = new Subject<any>();
  isInitialized : boolean;
  hardDeclineReasons : HardDeclineReason[];
  constructor(private location1: Location, private http : HttpClient,private location : Router, private activatedRoute: ActivatedRoute, private channels : ChannelService, 
    private dialogRef: MatDialog,private modalsrv: NgbModal,private toastr : ToastrService) {
    
   
  }

  authed : boolean;
  public get isAuthenticated() : boolean {
    if(!this.authed){
      this.authed = (localStorage.getItem("STP-JWT") != null && this.loggedInUser != undefined)
    }
    return this.authed;
  }

  public set isAuthenticated(v: boolean) {
    this.authed = v;
  }

  UserInRole(role:string): boolean
  {
    if(!this.loggedInUserRoles)return false;
    return this.loggedInUserRoles.filter(r => {return r.toLowerCase() == role.toLowerCase()}).length > 0;
  }

  GetToken(username:string, password:string) : Observable<Object>{
    return this.http.post(environment.baseURl + `/token`, {username, password});
  }

  ChangePassword(model: any) : Observable<Object>{
    return this.http.post(environment.baseURl + `/api/auth/password/change`, model);
  }

  SendForgotPasswordLink(username: string){
    return this.http.post(environment.baseURl + `/api/auth/password/SendForgotPasswordLink`, {username});
  }

  public ResetPassword(param: any ): Observable<Object> {
    return this.http.post(environment.baseURl + `/api/auth/password/ResetPassword`, param);
  }

  CreateUserInvite(dta : UserInvitation){
    return this.http.post(environment.baseURl + `/api/auth/user/invite`, dta);
  }

  GetUsersRoles(){
      this.http.get(environment.baseURl + '/api/auth/roles').subscribe(
        (s: any)=>{
          this.loggedInUserRoles = s;

          this.roleFetchComplete.next(true);
        },
        (err: any)=>{
          if(err.status == 401) this.logout('User Role error.. logout');
        });

        // also load the hard decline reasons since those are global
        this.FetchHardDeclineReasons();
  }

  GetLoggedInUser(){
    if(!this.loggedInUser || localStorage.getItem('STP-JWT') != null){
      this.http.get(environment.baseURl + '/api/user').subscribe(
        (s: any)=>{
          this.loggedInUser = s;
          this.authed = true;
          this.isInitialized = true;
          this.GetUsersRoles();
          this.userFetchComplete.next(true);
        },
        (err: any)=>{
          if(err.status == 401){
            this.logout('Logged in user 401 error.. logout');
            return;
          }
          this.userFetchComplete.next(err);
        })
    }else{
      this.logout('No User No Token... Logout');
    }
  }

  FetchUser(id : number): Observable<UserLight>{
    return this.http.get<UserLight>(environment.baseURl + `/api/auth/user/${id}`);
  }

  FetchHardDeclineReasons(){
    this.http.get(environment.baseURl + `/api/applicantdata/decline/reasons`).subscribe(
      (scc: HardDeclineReason[]) => { this.hardDeclineReasons = scc },
      (err: any) => { console.warn('error loading decline reasons') },
    )
  }

  WriteSourcesLog(dta : any){
    this.http.post(environment.baseURl + `/api/values/sources/log`,dta).subscribe(()=>{},()=>{});
  }

  LogOutUser(){
    return this.http.get(environment.baseURl + `/logout`);
  }


  logout(message:string = undefined){
    
    this.loggedInUserRoles = undefined;
    this.loggedInUser = undefined;
    this.isAuthenticated = false;
    this.authed = false;
    // This will allow us to go to the changepassword via token screen.. Otherwise we will redirect to login screen
    if (this.location1.path(false).indexOf('/changePasswordViaToken') === -1) {
      this.location.navigateByUrl('/login');
    }
    localStorage.removeItem('STP-JWT');

    this.channels.stop();
    this.logoutComplete.next();
    this.modalsrv.dismissAll();
    this.dialogRef.closeAll();
    this.toastr.clear();
  }
}
